import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Button as Button$1, CircularProgress, Typography as Typography$1, IconButton, Box, Switch, styled as styled$1, TextField, alpha, Popover, Autocomplete, Dialog, DialogTitle, DialogContent, TableContainer, Table as Table$1, TableBody, TablePagination, TableHead, TableRow, TableCell, Stack, CssBaseline, GlobalStyles as GlobalStyles$1 } from '@mui/material';
import React, { forwardRef, useState, useContext, useEffect, createContext, useMemo } from 'react';
import MuiTypography from '@mui/material/Typography';
import { styled, alpha as alpha$1, createTheme, StyledEngineProvider, ThemeProvider, useTheme } from '@mui/material/styles';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { isFunction, isString, merge } from 'lodash';
import NumberFormat from 'react-number-format';
import CloseIcon from '@mui/icons-material/Close';

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

/*
 * Why shouldn't use React.FC?
 * See: https://github.com/facebook/create-react-app/pull/8177
 * But i think in our case, it would be fine
 * */
/*
 * ButtonContained and ButtonOutlined are the same. Maybe we should merge them
 * TODO: Considering and do merge
 * */
var ButtonContained = function (_a) {
    var title = _a.title, children = _a.children, onClick = _a.onClick, disabled = _a.disabled, loading = _a.loading, sx = _a.sx, _b = _a.size, size = _b === void 0 ? "medium" : _b, props = __rest(_a, ["title", "children", "onClick", "disabled", "loading", "sx", "size"]);
    return (jsxs(Button$1, _assign({}, props, { onClick: onClick, disabled: disabled || loading, variant: "contained", size: size, sx: _assign({ "&:disabled": {
                bgcolor: "text.subBody",
                color: "text.paper",
            } }, sx) }, { children: [loading && (jsx(CircularProgress, { style: { width: 15, height: 15, color: "white", marginRight: 10 } })), title ? jsx(Typography$1, { children: title }) : children] })));
};

var ButtonOutlined = function (_a) {
    var title = _a.title, children = _a.children, onClick = _a.onClick, loading = _a.loading, disabled = _a.disabled, sx = _a.sx, _b = _a.size, size = _b === void 0 ? "medium" : _b, props = __rest(_a, ["title", "children", "onClick", "loading", "disabled", "sx", "size"]);
    return (jsxs(Button$1, _assign({}, props, { onClick: onClick, variant: "outlined", disabled: disabled || loading, size: size, sx: _assign({ borderColor: "text.subBody", color: "text.primary" }, sx) }, { children: [loading && jsx(CircularProgress, { style: { width: 15, height: 15, marginRight: 10 } }), title ? jsx(Typography$1, { children: title }) : children] })));
};

var ButtonInModal = function (_a) {
    var children = _a.children, onClick = _a.onClick, sx = _a.sx;
    return (jsx(ButtonContained, _assign({ onClick: onClick, sx: _assign({ width: "90%", color: "primary.main", bgcolor: "violet.lightest", "&:hover": { color: "text.paper" } }, sx) }, { children: children })));
};

var ButtonIcon = forwardRef(function (_a, ref) {
    var children = _a.children, other = __rest(_a, ["children"]);
    return (jsx(IconButton, _assign({ ref: ref }, other, { children: children })));
});

var GradientText = function (_a) {
    var _b = _a.startColor, startColor = _b === void 0 ? "#903AFD" : _b, _c = _a.endColor, endColor = _c === void 0 ? "#492CFF" : _c, children = _a.children, sx = _a.sx, other = __rest(_a, ["startColor", "endColor", "children", "sx"]);
    return (jsx(Typography$1, _assign({}, other, { sx: _assign({ background: "-webkit-linear-gradient(".concat(startColor, ", ").concat(endColor, ")"), WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }, sx) }, { children: children })));
};

var Typography = function (props) {
    return jsx(MuiTypography, _assign({}, props));
};

function SvgIconStyle(_a) {
    var src = _a.src, _b = _a.color, color = _b === void 0 ? "inherit" : _b, _c = _a.sx, sx = _c === void 0 ? { width: "100%", height: "100%" } : _c;
    return (jsx(Box, { component: "span", sx: _assign(_assign(_assign(_assign(_assign({ width: 24, height: 24, mask: "url(".concat(src, ") no-repeat center / contain"), WebkitMask: "url(".concat(src, ") no-repeat center / contain"), bgcolor: "".concat(color, ".main") }, (color === "inherit" && { bgcolor: "currentColor" })), (color === "action" && { bgcolor: "action.active" })), (color === "disabled" && { bgcolor: "action.disabled" })), (color === "paper" && { bgcolor: "background.paper" })), sx) }));
}

var SwitchBasic = styled(function (props) { return (jsx(Switch, _assign({ focusVisibleClassName: ".Mui-focusVisible", disableRipple: true }, props))); })(function (_a) {
    var theme = _a.theme;
    return ({
        width: 38,
        height: 20,
        padding: 0,
        "& .MuiSwitch-switchBase": {
            padding: 0,
            margin: 2,
            transitionDuration: "300ms",
            "&.Mui-checked": {
                transform: "translateX(18px)",
                color: "#fff",
                "& + .MuiSwitch-track": {
                    // backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
                    backgroundColor: "#34C759",
                    opacity: 1,
                    border: 0,
                },
                "&.Mui-disabled + .MuiSwitch-track": {
                    opacity: 0.5,
                },
            },
            "&.Mui-focusVisible .MuiSwitch-thumb": {
                // color: "#33cf4d",
                color: "#34C759",
                border: "6px solid #fff",
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
                color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600],
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
            },
        },
        "& .MuiSwitch-thumb": {
            boxSizing: "border-box",
            width: 16,
            height: 16,
        },
        "& .MuiSwitch-track": {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
            opacity: 1,
            transition: theme.transitions.create(["background-color"], {
                duration: 500,
            }),
        },
    });
});

var FizenTextField = styled$1(TextField)(function (_a) {
    var theme = _a.theme;
    return ({
        "& .MuiFilledInput-root": {
            border: "1px solid white",
            overflow: "hidden",
            borderRadius: 4,
            backgroundColor: "white",
            borderColor: "#DBDBDB",
            transition: theme.transitions.create(["border-color", "background-color", "box-shadow"]),
            "&:hover": {
                backgroundColor: "white",
                borderColor: theme.palette.primary.main,
                boxShadow: "".concat(alpha(theme.palette.primary.main, 0.25), " 0 0 0 2px"),
            },
            "&.Mui-focused": {
                backgroundColor: "white",
                borderColor: theme.palette.primary.main,
            },
            "&.Mui-error": {
                borderColor: theme.palette.error.main,
            },
        },
        "& .MuiInputLabel-root": {
            // @ts-ignore
            color: theme.palette.text.subBody,
            "&.Mui-focused": {
                color: theme.palette.primary.main,
            },
            "&.Mui-error": {
                // @ts-ignore
                color: theme.palette.text.subBody,
            },
        },
    });
});
var Input = forwardRef(function (_a, ref) {
    var value = _a.value, onChange = _a.onChange, name = _a.name, label = _a.label, sx = _a.sx, props = __rest(_a, ["value", "onChange", "name", "label", "sx"]);
    return (jsx(FizenTextField, _assign({}, props, { value: value, onChange: onChange, name: name, margin: "dense", label: label, fullWidth: true, variant: "filled", sx: _assign({ marginY: 1 }, sx), InputProps: _assign({ style: {
            // color: "white",
            }, disableUnderline: true }, props.InputProps), InputLabelProps: {
            style: {
            // color: "white",
            },
        } })));
});

var ArrowStyle = styled("span")(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[theme.breakpoints.up("sm")] = {
            top: -7,
            zIndex: 1,
            width: 12,
            right: 20,
            height: 12,
            content: "''",
            position: "absolute",
            borderRadius: "0 0 4px 0",
            transform: "rotate(-135deg)",
            background: theme.palette.background.paper,
            borderRight: "solid 1px ".concat(alpha$1(theme.palette.grey[500], 0.12)),
            borderBottom: "solid 1px ".concat(alpha$1(theme.palette.grey[500], 0.12)),
        },
        _b);
});
function MenuPopover(_a) {
    var children = _a.children, sx = _a.sx, other = __rest(_a, ["children", "sx"]);
    return (jsxs(Popover, _assign({ anchorOrigin: { vertical: "bottom", horizontal: "right" }, transformOrigin: { vertical: "top", horizontal: "right" }, PaperProps: {
            sx: _assign({ mt: 1.5, ml: 0.5, overflow: "inherit", 
                // boxShadow: (theme) => theme.customShadows.z20,
                // @ts-ignore
                border: function (theme) { return "solid 1px ".concat(theme.palette.grey[5008]); }, width: 200 }, sx),
        } }, other, { children: [jsx(ArrowStyle, { className: "arrow" }), children] })));
}

var Form = function (_a) {
    var formModel = _a.formModel, onFinish = _a.onFinish, initialValue = _a.initialValue, formButton = _a.formButton, validationSchema = _a.validationSchema, form = _a.form;
    var privateForm = useForm({
        defaultValues: initialValue,
        resolver: validationSchema ? yupResolver(validationSchema) : undefined,
    });
    var _b = form !== null && form !== void 0 ? form : privateForm, 
    // register,
    watch = _b.watch, control = _b.control, handleSubmit = _b.handleSubmit, setValue = _b.setValue, errors = _b.formState.errors;
    var onSubmit = function (data) { return onFinish(data); };
    return (jsxs("form", _assign({ onSubmit: handleSubmit(onSubmit) }, { children: [Object.entries(formModel).map(function (_a, idx) {
                var key = _a[0], value = _a[1];
                switch (value.type) {
                    case "string":
                        return (jsx(Controller, { name: key, control: control, 
                            // defaultValue={initialValue[key]}
                            // rules={value.rules}
                            render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (
                                // style === "light" ? (
                                //   <TextField
                                //     {...field}
                                //     error={!!errors[key]}
                                //     helperText={errors[key]?.message}
                                //     label={value.label}
                                //     sx={value.sx}
                                //     autoFocus={idx === 0}
                                //     variant="filled"
                                //   />
                                // ) : (
                                jsx(Input, _assign({}, field, { error: !!errors[key], helperText: (_b = errors[key]) === null || _b === void 0 ? void 0 : _b.message, label: value.label, sx: value.sx, autoFocus: idx === 0 })));
                            } }, key));
                    case "password":
                        return (jsx(Controller, { name: key, control: control, 
                            // defaultValue={initialValue[key]}
                            // rules={value.rules}
                            render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (
                                // style === "light" ? (
                                //   <TextField
                                //     {...field}
                                //     label={value.label}
                                //     sx={value.sx}
                                //     type="password"
                                //     error={!!errors[key]}
                                //     helperText={errors[key]?.message}
                                //     autoFocus={idx === 0}
                                //   />
                                // ) : (
                                jsx(Input, _assign({}, field, { label: value.label, sx: value.sx, type: "password", error: !!errors[key], helperText: (_b = errors[key]) === null || _b === void 0 ? void 0 : _b.message, autoFocus: idx === 0 })));
                            } }, key));
                    case "number":
                        return (jsx(Controller, { name: key, control: control, 
                            // defaultValue={initialValue[key]}
                            // rules={value.rules}
                            render: function (_a) {
                                var _b;
                                var _c = _a.field, ref = _c.ref, props = __rest(_c, ["ref"]);
                                return (
                                // <TextField
                                //     {...field}
                                //     error={!!errors[key]}
                                //     helperText={errors[key]?.message}
                                //     label={value.label}
                                //     sx={value.sx}
                                //     InputProps={{
                                //       inputComponent: NumberInput
                                //     }}
                                // />
                                jsx(NumberFormat, _assign({}, props, { customInput: Input, onValueChange: function (v) {
                                        console.log(v);
                                        props.onChange(v.floatValue);
                                    }, value: props.value, thousandSeparator: true, inputRef: ref, 
                                    // isNumericString
                                    decimalScale: value.decimalScale, prefix: value.prefix, suffix: value.suffix, error: !!errors[key], helperText: (_b = errors[key]) === null || _b === void 0 ? void 0 : _b.message, label: value.label, sx: value.sx, autoFocus: idx === 0, allowNegative: value.allowNegative })));
                            } }, key));
                    case "select":
                        return (jsx(Controller, { name: key, control: control, 
                            // defaultValue={initialValue[key]}
                            // rules={value.rules}
                            render: function (_a) {
                                var _b = _a.field, onChange = _b.onChange, props = __rest(_b, ["onChange"]);
                                if (!value.options) {
                                    value.options = [];
                                }
                                var index = value.options.findIndex(function (item) { return item.value === props.value; });
                                var init = value.options[index];
                                return (jsx(Autocomplete, { sx: value.sx, getOptionLabel: function (option) { return option.label; }, options: value.options, renderInput: function (params) { return jsx(TextField, _assign({}, params, { label: value.label })); }, onChange: function (e, data) { return onChange(data === null || data === void 0 ? void 0 : data.value); }, value: init }));
                            } }, key));
                    case "multiple-select":
                        return (jsx(Controller, { name: key, control: control, 
                            // defaultValue={initialValue[key]}
                            // rules={value.rules}
                            render: function (_a) {
                                var _b = _a.field, onChange = _b.onChange, props = __rest(_b, ["onChange"]);
                                if (!value.options) {
                                    value.options = [];
                                }
                                return (jsx(Autocomplete, { sx: value.sx, multiple: true, getOptionLabel: function (option) { var _a; return value.mappingLabel ? (_a = value.mappingLabel[option]) !== null && _a !== void 0 ? _a : option : option; }, options: value.options, renderInput: function (params) {
                                        var _a;
                                        return (jsx(TextField, _assign({}, params, { label: value.label, error: !!errors[key], helperText: (_a = errors[key]) === null || _a === void 0 ? void 0 : _a.message })));
                                    }, onChange: function (e, data) {
                                        if (value.limitTags) {
                                            if (data.length <= value.limitTags) {
                                                onChange(data);
                                            }
                                        }
                                        else {
                                            onChange(data);
                                        }
                                    }, value: props.value }));
                            } }, key));
                    default:
                        return jsx(Fragment, {});
                }
            }), isFunction(formButton)
                ? formButton({ control: control, currentValue: watch(), setValue: setValue })
                : formButton] })));
};

var ModalContext = React.createContext({
    openModal: function () { },
    closeModal: function () { },
});
var ModalProvider = function (_a) {
    var children = _a.children;
    var _b = useState(), ModalNode = _b[0], setModalNode = _b[1];
    var onClose = function () {
        setModalNode(undefined);
    };
    return (jsxs(ModalContext.Provider, _assign({ value: {
            openModal: function (modal, modalProps, modalNode) {
                setModalNode({
                    modalComponent: modal,
                    modalProps: modalProps,
                    modalNode: modalNode,
                });
            },
            closeModal: onClose,
        } }, { children: [ModalNode && (jsxs(Fragment, { children: [ModalNode.modalComponent && (jsx(ModalNode.modalComponent, _assign({}, _assign({ onClose: onClose }, ModalNode.modalProps)))), ModalNode.modalNode && ModalNode.modalNode] })), children] })));
};
function useModal() {
    return useContext(ModalContext);
}

var Modal = function (_a) {
    var onClose = _a.onClose, title = _a.title, children = _a.children; _a.divider; var _b = _a.DialogContentProps, DialogContentProps = _b === void 0 ? { sx: { px: 10 } } : _b, _c = _a.DialogTitleProps, DialogTitleProps = _c === void 0 ? { sx: { px: 10 } } : _c, sx = _a.sx, _d = _a.options, options = _d === void 0 ? {
        closeIcon: jsx(CloseIcon, {}),
    } : _d;
    return (jsxs(Dialog, _assign({ open: true, onClose: onClose, sx: sx }, { children: [jsx(DialogTitle, _assign({}, DialogTitleProps, { children: options.closeIcon ? (jsx(IconButton, _assign({ "aria-label": "close", onClick: onClose, sx: {
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: function (theme) { return theme.palette.grey[500]; },
                    } }, { children: options.closeIcon }))) : null })), jsxs(DialogContent, _assign({}, DialogContentProps, { children: [title && (jsx(GradientText, _assign({ component: "p", align: "center", variant: "big", mb: 1.5 }, { children: title }))), children] }))] })));
};

function FormModal(_a) {
    var onClose = _a.onClose, title = _a.title, formModel = _a.formModel, onFinish = _a.onFinish, initialValue = _a.initialValue, formButton = _a.formButton, validationSchema = _a.validationSchema, form = _a.form, sx = _a.sx, _b = _a.DialogContentProps, DialogContentProps = _b === void 0 ? { sx: { px: 10 } } : _b;
    return (jsxs(Modal, _assign({ onClose: onClose, sx: sx, title: "", DialogContentProps: DialogContentProps }, { children: [jsx(GradientText, _assign({ component: "p", align: "center", variant: "big", mb: 2 }, { children: title })), jsx(Form, { formModel: formModel, initialValue: initialValue, formButton: formButton, validationSchema: validationSchema, onFinish: onFinish, form: form })] })));
}

var NoResults = function () {
    return (jsx("div", _assign({ className: "flex justify-center items-center" }, { children: jsx(Typography$1, _assign({ variant: "body1" }, { children: "No results" })) })));
};

var Header = function (_a) {
    var columns = _a.columns, headerProps = _a.headerProps;
    return (jsx(TableHead, _assign({ sx: _assign({ bgcolor: "#EEEBFF" }, headerProps) }, { children: jsx(TableRow, { children: columns.map(function (_a, idx) {
                var HeaderComponent = _a.header, headerLabel = _a.headerLabel, headerStyle = _a.headerStyle;
                return (jsx(TableCell, _assign({ sx: _assign({ "&.MuiTableCell-root": { padding: "16px 40px" }, borderTopLeftRadius: idx === 0 ? 6 : 0, borderTopRightRadius: idx === columns.length - 1 ? 6 : 0 }, headerStyle) }, { children: jsx(HeaderComponent, { label: headerLabel }) }), headerLabel));
            }) }) })));
};
var CustomRow = function (_a) {
    var row = _a.row, columns = _a.columns, rowProps = _a.rowProps;
    return (jsx(TableRow, _assign({}, (rowProps || {}), { sx: {
            cursor: rowProps ? "pointer" : "default",
            bgcolor: "background.paper",
        } }, { children: columns.map(function (_a, idx) {
            var Content = _a.cell, align = _a.align, sx = _a.sx;
            return (jsx(TableCell, _assign({ align: align, sx: _assign({ "&.MuiTableCell-root": { padding: "16px 40px" } }, sx) }, { children: jsx(Content, _assign({}, row)) }), idx));
        }) })));
};
function Table(_a) {
    var _b = _a.data, data = _b === void 0 ? [] : _b, columns = _a.columns, noResults = _a.noResults, primaryKey = _a.primaryKey, pagination = _a.pagination, handleChangePage = _a.handleChangePage, handleChangeRowsPerPage = _a.handleChangeRowsPerPage, sxTable = _a.sxTable, deriveRowProps = _a.deriveRowProps, loading = _a.loading, _c = _a.hideHeader, hideHeader = _c === void 0 ? false : _c, headerProps = _a.headerProps;
    return (jsx(Fragment, { children: jsxs(TableContainer, { children: [jsxs(Table$1, _assign({ sx: _assign({}, sxTable) }, { children: [!hideHeader && jsx(Header, { columns: columns, headerProps: headerProps }), !loading && (jsx(TableBody, { children: data.map(function (row) { return (jsx(CustomRow, { row: row, columns: columns, rowProps: deriveRowProps ? deriveRowProps(row) : undefined }, isString(primaryKey)
                                ? row[primaryKey]
                                : "".concat(primaryKey.prefix, "-").concat(row[primaryKey.key]))); }) }))] })), !loading && data.length === 0 && jsx(Fragment, { children: noResults ? jsx(Box, { children: noResults }) : jsx(NoResults, {}) }), loading && (jsx("div", _assign({ className: "flex justify-center items-center mt-5 h-[100px]" }, { children: jsx(CircularProgress, { size: 30 }) }))), pagination && (jsx(TablePagination, { component: "div", rowsPerPageOptions: [5, 10, 25, 50, 100], count: pagination.total, page: pagination.page - 1, onPageChange: handleChangePage, rowsPerPage: pagination.limit, onRowsPerPageChange: handleChangeRowsPerPage, showFirstButton: true, showLastButton: true }))] }) }));
}

var Chip = function (_a) {
    var label = _a.label, color = _a.color, bgcolor = _a.bgcolor;
    return (jsx(Stack, _assign({ justifyContent: "center", alignItems: "center", paddingY: 0.5, paddingX: 1, sx: { bgcolor: bgcolor, borderRadius: 5, display: "inline-flex" } }, { children: jsx(Typography$1, _assign({ variant: "smallText", sx: { color: color } }, { children: label })) })));
};

// ----------------------------------------------------------------------
function useLocalStorage(key, defaultValue) {
    var _a = useState(function () {
        var storedValue = localStorage.getItem(key);
        return storedValue === null ? defaultValue : JSON.parse(storedValue);
    }), value = _a[0], setValue = _a[1];
    useEffect(function () {
        var listener = function (e) {
            if (e.storageArea === localStorage && e.key === key) {
                setValue(JSON.parse(e.newValue));
            }
        };
        window.addEventListener("storage", listener);
        return function () {
            window.removeEventListener("storage", listener);
        };
    }, [key, defaultValue]);
    var setValueInLocalStorage = function (newValue) {
        setValue(function (currentValue) {
            var result = typeof newValue === "function" ? newValue(currentValue) : newValue;
            localStorage.setItem(key, JSON.stringify(result));
            return result;
        });
    };
    return [value, setValueInLocalStorage];
}

// ----------------------------------------------------------------------
function createGradient(color1, color2) {
    return "linear-gradient(to bottom, ".concat(color1, ", ").concat(color2, ")");
}
// SETUP COLORS
var GREY = {
    0: "#FFFFFF",
    100: "#F9FAFB",
    200: "#F4F6F8",
    300: "#DFE3E8",
    400: "#C4CDD5",
    500: "#919EAB",
    600: "#637381",
    700: "#454F5B",
    800: "#212B36",
    900: "#161C24",
    5008: alpha$1("#919EAB", 0.08),
    50012: alpha$1("#919EAB", 0.12),
    50016: alpha$1("#919EAB", 0.16),
    50024: alpha$1("#919EAB", 0.24),
    50032: alpha$1("#919EAB", 0.32),
    50048: alpha$1("#919EAB", 0.48),
    50056: alpha$1("#919EAB", 0.56),
    50080: alpha$1("#919EAB", 0.8),
};
var PRIMARY = {
    lightest: "#C8FACD",
    lighter: "#C8FACD",
    light: "#5BE584",
    main: "#00AB55",
    dark: "#007B55",
    darker: "#005249",
    contrastText: "#fff",
};
var SECONDARY = {
    lightest: "#D6E4FF",
    lighter: "#D6E4FF",
    light: "#84A9FF",
    main: "#3366FF",
    dark: "#1939B7",
    darker: "#091A7A",
    contrastText: "#fff",
};
var INFO = {
    lightest: "#CCDFFF",
    lighter: "#CCDFFF",
    light: "#6697FF",
    main: "#0045FF",
    dark: "#0027B7",
    darker: "#00137A",
    contrastText: "#fff",
};
var SUCCESS = {
    lightest: "#E9FCD4",
    lighter: "#E9FCD4",
    light: "#8AC770",
    main: "#54D62C",
    dark: "#229A16",
    darker: "#08660D",
    contrastText: GREY[800],
};
var WARNING = {
    lightest: "#FFF7CD",
    lighter: "#FFF7CD",
    light: "#FFE16A",
    main: "#FFC107",
    dark: "#E19635",
    darker: "#7A4F01",
    contrastText: GREY[800],
};
var ERROR = {
    lightest: "#FFE7D9",
    lighter: "#FFE7D9",
    light: "#FFA48D",
    main: "#C11616",
    dark: "#DA1242",
    darker: "#7A0C2E",
    contrastText: "#fff",
};
var VIOLET = {
    lightest: "#EEE7F9",
    lighter: "#903AFD",
    light: "#492CFF",
    main: "#500EC1",
    dark: "#6304FF",
    darker: "#6304FF",
    contrastText: "#fff",
};
var GRADIENTS = {
    primary: createGradient(PRIMARY.light, PRIMARY.main),
    info: createGradient(INFO.light, INFO.main),
    success: createGradient(SUCCESS.light, SUCCESS.main),
    warning: createGradient(WARNING.light, WARNING.main),
    error: createGradient(ERROR.light, ERROR.main),
    violet: createGradient(VIOLET.lighter, VIOLET.light),
};
var CHART_COLORS = {
    violet: ["#826AF9", "#9E86FF", "#D0AEFF", "#F7D2FF"],
    blue: ["#2D99FF", "#83CFFF", "#A5F3FF", "#CCFAFF"],
    green: ["#2CD9C5", "#60F1C8", "#A4F7CC", "#C0F2DC"],
    yellow: ["#FFE700", "#FFEF5A", "#FFF7AE", "#FFF3D6"],
    red: ["#FF6C40", "#FF8F6D", "#FFBD98", "#FFF2D4"],
};
var COMMON = {
    common: { black: "#282736", white: "#fff" },
    primary: _assign({}, PRIMARY),
    secondary: _assign({}, SECONDARY),
    info: _assign({}, INFO),
    success: _assign({}, SUCCESS),
    warning: _assign({}, WARNING),
    error: _assign({}, ERROR),
    violet: _assign({}, VIOLET),
    grey: GREY,
    gradients: GRADIENTS,
    chart: CHART_COLORS,
    divider: GREY[50024],
    action: {
        hover: GREY[5008],
        selected: GREY[50016],
        disabled: GREY[50080],
        disabledBackground: GREY[50024],
        focus: GREY[50024],
        hoverOpacity: 0.08,
        disabledOpacity: 0.48,
    },
};
var palette = {
    light: _assign(_assign({}, COMMON), { text: {
            primary: "#282736",
            secondary: "#282736",
            disabled: GREY[500],
            subBody: "#8089A9",
            paper: "#fff",
            black: "#000000",
        }, background: {
            paper: "#fff",
            default: "#fff",
            neutral: GREY[200],
            grey: "rgba(255, 255, 255, 0.3)",
            lightGrey: "rgba(255, 255, 255, 0.2)",
        }, action: _assign({ active: GREY[600] }, COMMON.action) }),
    dark: _assign(_assign({}, COMMON), { text: {
            primary: "#fff",
            secondary: GREY[500],
            disabled: GREY[600],
            grey: "rgba(255, 255, 255, 0.3)",
        }, background: { paper: GREY[800], default: GREY[900], neutral: GREY[50016] }, action: _assign({ active: GREY[500] }, COMMON.action) }),
};

var PRIMARY_COLOR = [
    _assign({ name: "default" }, palette.light.primary),
    // PURPLE
    {
        name: "purple",
        lighter: "#EBD6FD",
        light: "#B985F4",
        main: "#500EC1",
        dark: "#742eee",
        darker: "#200A69",
        contrastText: "#fff",
    },
    // CYAN
    {
        name: "cyan",
        lighter: "#D1FFFC",
        light: "#76F2FF",
        main: "#1CCAFF",
        dark: "#0E77B7",
        darker: "#053D7A",
        contrastText: palette.light.grey[800],
    },
    // BLUE
    {
        name: "blue",
        lighter: "#CCDFFF",
        light: "#6697FF",
        main: "#0045FF",
        dark: "#0027B7",
        darker: "#00137A",
        contrastText: "#fff",
    },
    // ORANGE
    {
        name: "orange",
        lighter: "#FEF4D4",
        light: "#FED680",
        main: "#fda92d",
        dark: "#B66816",
        darker: "#793908",
        contrastText: palette.light.grey[800],
    },
    // RED
    {
        name: "red",
        lighter: "#FFE3D5",
        light: "#FFC1AC",
        main: "#FF3030",
        dark: "#B71833",
        darker: "#7A0930",
        contrastText: "#fff",
    },
];
function SetColor(themeColor) {
    var color;
    var DEFAULT = PRIMARY_COLOR[0];
    var PURPLE = PRIMARY_COLOR[1];
    var CYAN = PRIMARY_COLOR[2];
    var BLUE = PRIMARY_COLOR[3];
    var ORANGE = PRIMARY_COLOR[4];
    var RED = PRIMARY_COLOR[5];
    switch (themeColor) {
        case "purple":
            color = PURPLE;
            break;
        case "cyan":
            color = CYAN;
            break;
        case "blue":
            color = BLUE;
            break;
        case "orange":
            color = ORANGE;
            break;
        case "red":
            color = RED;
            break;
        default:
            color = DEFAULT;
    }
    return color;
}
var initialState = {
    themeMode: "light",
    themeDirection: "ltr",
    themeColor: "purple",
    themeStretch: false,
    onChangeMode: function () { },
    onChangeDirection: function () { },
    onChangeColor: function () { },
    onToggleStretch: function () { },
    setColor: PRIMARY_COLOR[1],
    colorOption: [],
};
var SettingsContext = createContext(initialState);
var SettingsProvider = function (_a) {
    var children = _a.children;
    var _b = useLocalStorage("settings", {
        themeMode: initialState.themeMode,
        themeDirection: initialState.themeDirection,
        themeColor: initialState.themeColor,
        themeStretch: initialState.themeStretch,
    }), settings = _b[0], setSettings = _b[1];
    var onChangeMode = function (mode) {
        setSettings(_assign(_assign({}, settings), { themeMode: mode }));
    };
    var onChangeDirection = function (direction) {
        setSettings(_assign(_assign({}, settings), { themeDirection: direction }));
    };
    var onChangeColor = function (color) {
        setSettings(_assign(_assign({}, settings), { themeColor: color }));
    };
    var onToggleStretch = function () {
        setSettings(_assign(_assign({}, settings), { themeStretch: !settings.themeStretch }));
    };
    return (jsx(SettingsContext.Provider, _assign({ value: _assign(_assign({}, settings), { 
            // Mode
            onChangeMode: onChangeMode, 
            // Direction
            onChangeDirection: onChangeDirection, 
            // Color
            onChangeColor: onChangeColor, setColor: SetColor(settings.themeColor), colorOption: PRIMARY_COLOR.map(function (color) { return ({
                name: color.name,
                value: color.main,
            }); }), 
            // Stretch
            onToggleStretch: onToggleStretch }) }, { children: children })));
};
var useSettings = function () { return useContext(SettingsContext); };

// ----------------------------------------------------------------------
function pxToRem(value) {
    return "".concat(value / 16, "rem");
}
function responsiveFontSizes(_a) {
    var sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl;
    return {
        "@media (min-width:600px)": {
            fontSize: pxToRem(sm),
        },
        "@media (min-width:900px)": {
            fontSize: pxToRem(md),
        },
        "@media (min-width:1200px)": {
            fontSize: pxToRem(lg),
        },
        "@media (min-width:1600px)": {
            fontSize: pxToRem(xl),
        },
    };
}
var FONT_PRIMARY = "quicksand, sans-serif"; // Google Font
// const FONT_SECONDARY = 'CircularStd, sans-serif'; // Local Font
var typography = {
    fontFamily: FONT_PRIMARY,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    h1: _assign({ fontWeight: 700, lineHeight: 80 / 64, fontSize: pxToRem(40) }, responsiveFontSizes({ sm: 52, md: 58, lg: 64 })),
    h2: _assign({ fontWeight: 700, lineHeight: 64 / 48, fontSize: pxToRem(32) }, responsiveFontSizes({ sm: 40, md: 44, lg: 48 })),
    h3: _assign({ fontWeight: 700, lineHeight: 1.5, fontSize: pxToRem(24) }, responsiveFontSizes({ sm: 26, md: 30, lg: 32 })),
    h4: _assign({ fontWeight: 700, lineHeight: 1.5, fontSize: pxToRem(20) }, responsiveFontSizes({ sm: 20, md: 24, lg: 24 })),
    h5: {
        fontWeight: 700,
        lineHeight: 1.5,
        fontSize: pxToRem(18),
        // ...responsiveFontSizes({ sm: 19, md: 19, lg: 19, xl: 20 }),
    },
    h6: _assign({ fontWeight: 700, lineHeight: 28 / 18, fontSize: pxToRem(17) }, responsiveFontSizes({ sm: 18, md: 18, lg: 18 })),
    header: {
        fontWeight: 700,
        lineHeight: pxToRem(38),
        fontSize: pxToRem(28),
    },
    title: {
        fontWeight: 700,
        lineHeight: 1.5,
        fontSize: pxToRem(18),
    },
    subtitle: {
        fontWeight: 600,
        lineHeight: 1.5,
        fontSize: pxToRem(16),
        // ...responsiveFontSizes({ sm: 16, md: 18, lg: 20, xl: 22 }),
    },
    text700: {
        fontWeight: 700,
        lineHeight: 1.5,
        fontSize: pxToRem(14),
        // ...responsiveFontSizes({ sm: 14, md: 16, lg: 18, xl: 20 }),
    },
    text600: _assign({ fontWeight: 600, lineHeight: 1.5, fontSize: pxToRem(14) }, responsiveFontSizes({ sm: 14, md: 16, lg: 18, xl: 20 })),
    text500: {
        fontWeight: 500,
        lineHeight: 1.5,
        fontSize: pxToRem(14),
        // ...responsiveFontSizes({ sm: 14, md: 16, lg: 18, xl: 20 }),
    },
    text400: {
        fontWeight: 400,
        lineHeight: 1.5,
        fontSize: pxToRem(14),
    },
    lead: {
        fontWeight: 500,
        lineHeight: 1.5,
        fontSize: pxToRem(12),
        // ...responsiveFontSizes({ sm: 12, md: 14, lg: 16, xl: 18 }),
    },
    text: {
        fontWeight: 500,
        lineHeight: 1.5,
        fontSize: pxToRem(14),
    },
    smallText: {
        fontWeight: 500,
        lineHeight: 1.5,
        fontSize: pxToRem(12),
    },
    big: {
        fontWeight: 700,
        lineHeight: 1.5,
        fontSize: pxToRem(24),
        // ...responsiveFontSizes({ sm: 20, md: 24, lg: 24, xl: 24 }),
    },
    medium: _assign({ color: "text.secondary", lineHeight: 1.5, fontSize: pxToRem(16) }, responsiveFontSizes({ sm: 18, md: 18, lg: 18 })),
    button: {
        fontWeight: 700,
        lineHeight: 24 / 14,
        fontSize: pxToRem(14),
        textTransform: "capitalize",
    },
};

var breakpoints = {
    values: {
        xs: 0,
        xss: 500,
        sm: 600,
        md: 900,
        lg: 1200,
        mac: 1440,
        xl: 1536,
        fhd: 1920,
        qhd: 2560,
    },
};

// ----------------------------------------------------------------------
function Button(theme) {
    return {
        MuiButton: {
            styleOverrides: {
                root: {
                    "&:hover": {
                        boxShadow: "none",
                    },
                    minHeight: 36,
                    borderRadius: "22px",
                    padding: "4px 16px",
                    boxShadow: "none",
                    textTransform: "none",
                },
                sizeMedium: {
                    height: 36,
                    fontSize: 14,
                },
                sizeLarge: {
                    height: 50,
                    fontSize: 14,
                },
                // contained
                containedInherit: {
                    color: theme.palette.grey[800],
                    // boxShadow: theme.customShadows.z8,
                    "&:hover": {
                        backgroundColor: theme.palette.grey[400],
                    },
                },
                containedPrimary: {
                // boxShadow: theme.customShadows.primary
                },
                containedSecondary: {
                // boxShadow: theme.customShadows.secondary
                },
                containedInfo: {
                // boxShadow: theme.customShadows.info
                },
                containedSuccess: {
                // boxShadow: theme.customShadows.success
                },
                containedWarning: {
                // boxShadow: theme.customShadows.warning
                },
                containedError: {
                // boxShadow: theme.customShadows.error
                },
                // outlined
                outlinedInherit: {
                    // @ts-ignore
                    border: "1px solid ".concat(theme.palette.grey[50032]),
                    "&:hover": {
                        backgroundColor: theme.palette.action.hover,
                    },
                },
                textInherit: {
                    "&:hover": {
                        backgroundColor: theme.palette.action.hover,
                    },
                },
            },
        },
    };
}

function ComponentsOverrides(theme) {
    return merge(Button(theme));
}

// ----------------------------------------------------------------------
var ThemeConfig = function (_a) {
    var children = _a.children;
    var _b = useSettings(), themeMode = _b.themeMode, themeDirection = _b.themeDirection;
    var isLight = themeMode === "light";
    var themeOptions = useMemo(function () { return ({
        palette: isLight ? _assign(_assign({}, palette.light), { mode: "light" }) : _assign(_assign({}, palette.dark), { mode: "dark" }),
        // shape,
        typography: typography,
        breakpoints: breakpoints,
        direction: themeDirection,
        // shadows: isLight ? shadows.light : shadows.dark,
        // customShadows: isLight ? customShadows.light : customShadows.dark
    }); }, [isLight, themeDirection]);
    var theme = createTheme(themeOptions);
    theme.components = ComponentsOverrides(theme);
    return (jsx(StyledEngineProvider, _assign({ injectFirst: true }, { children: jsxs(ThemeProvider, _assign({ theme: theme }, { children: [jsx(CssBaseline, {}), children] })) })));
};

var ThemePrimaryColor = function (_a) {
    var children = _a.children;
    var defaultTheme = useTheme();
    var setColor = useSettings().setColor;
    var themeOptions = useMemo(function () { return (_assign(_assign({}, defaultTheme), { palette: _assign(_assign({}, defaultTheme.palette), { primary: setColor }), customShadows: {
            // ...defaultTheme.customShadows,
            primary: "0 8px 16px 0 ".concat(alpha$1(setColor.main, 0.24)),
        } })); }, [setColor, defaultTheme]);
    var theme = createTheme(themeOptions);
    theme.components = ComponentsOverrides(theme);
    return jsx(ThemeProvider, _assign({ theme: theme }, { children: children }));
};

var FizenProvider = function (_a) {
    var children = _a.children;
    return (jsx(ThemeConfig, { children: jsx(ThemePrimaryColor, { children: children }) }));
};

// ----------------------------------------------------------------------
function GlobalStyles() {
    var theme = useTheme();
    return (jsx(GlobalStyles$1, { styles: {
            "*": {
                margin: 0,
                padding: 0,
                boxSizing: "border-box",
            },
            html: {
                width: "100%",
                height: "100%",
                WebkitOverflowScrolling: "touch",
            },
            body: {
                width: "100%",
                height: "100%",
            },
            "#root": {
                width: "100%",
                height: "100%",
            },
            input: {
                "&[type=number]": {
                    MozAppearance: "textfield",
                    "&::-webkit-outer-spin-button": {
                        margin: 0,
                        WebkitAppearance: "none",
                    },
                    "&::-webkit-inner-spin-button": {
                        margin: 0,
                        WebkitAppearance: "none",
                    },
                },
            },
            textarea: {
                "&::-webkit-input-placeholder": {
                    color: theme.palette.text.disabled,
                },
                "&::-moz-placeholder": {
                    opacity: 1,
                    color: theme.palette.text.disabled,
                },
                "&:-ms-input-placeholder": {
                    color: theme.palette.text.disabled,
                },
                "&::placeholder": {
                    color: theme.palette.text.disabled,
                },
            },
            img: { display: "block", maxWidth: "100%" },
            // Lazy Load Img
            ".blur-up": {
                WebkitFilter: "blur(5px)",
                filter: "blur(5px)",
                transition: "filter 400ms, -webkit-filter 400ms",
            },
            ".blur-up.lazyloaded ": {
                WebkitFilter: "blur(0)",
                filter: "blur(0)",
            },
        } }));
}

export { ButtonContained, ButtonIcon, ButtonInModal, ButtonOutlined, Chip, FizenProvider, Form, FormModal, GlobalStyles, GradientText, Input, MenuPopover, Modal, ModalProvider, NoResults, SetColor, SettingsProvider, SvgIconStyle, SwitchBasic as Switch, Table, ThemeConfig, ThemePrimaryColor, Typography, breakpoints, palette as colors, typography, useModal, useSettings };
